import React, { useEffect } from "react";
import { data } from "../../util/data";
import "./Project.css";
import ProjectDetails from "./ProjectDetails";
import "aos/dist/aos.css";
import Aos from "aos";
const Project = () => {
  useEffect(() => {
    Aos.init({
      duration: 2000,
    });
  }, [0]);
  return (
    <>
      {data.map((item, index) => (
        <ProjectDetails item={item}></ProjectDetails>
      ))}
    </>
  );
};

export default Project;
